import { AlertHelper } from "helpers";
import {
  isAdmin,
  isOperator,
  isPlanner,
  isSuperAdmin,
  isSupervisor,
  isViewer,
} from "helpers/roleHelper";
import {
  EQualityCheckingConditionValue,
  EUnitPosition,
  IApiResponse
} from "model";
import { FileApiService } from "services";
import { translations } from "utils/i18n";

export const getUnitPositionName = (position: EUnitPosition) => {
  switch (position) {
    case EUnitPosition.HEAD: {
      return translations.inProcessCheckReportDetail.positionHead;
    }
    case EUnitPosition.BODY: {
      return translations.inProcessCheckReportDetail.positionBody;
    }
    case EUnitPosition.TAIL: {
      return translations.inProcessCheckReportDetail.positionTail;
    }
  }
};

export const getQualityConditionValue = (value: string) => {
  switch (value) {
    case EQualityCheckingConditionValue.No.toString(): {
      return translations.inProcessCheckReportDetail.statusValue.no;
    }
    case EQualityCheckingConditionValue.Yes.toString(): {
      return translations.inProcessCheckReportDetail.statusValue.yes;
    }
    case EQualityCheckingConditionValue.NoUse.toString(): {
      return translations.inProcessCheckReportDetail.statusValue.noUse;
    }
  }
};

export const deletePhoto = async (url: string) => {
  const urlSplitted = url.split("/");
  const id = urlSplitted[urlSplitted.length - 1].replace(/\.[^/.]+$/, "");
  try {
    const result = (await FileApiService.deleteFile(
      id
    )) as IApiResponse<string>;
    if (result.succeeded) {
      return result.succeeded;
    } else {
      AlertHelper.showError(result);
      return false;
    }
  } catch (error) {
    console.log("Network Error", error);
    return false;
  } finally {
  }
};

export const canPerformAndReview = () => {
  return isOperator() || isSupervisor() || isAdmin() || isSuperAdmin();
};
export const canEditAfterReview = () => {
  return isSuperAdmin() || isAdmin() || isSupervisor();
};
export const canViewAndDownload = () => {
  return (
    isPlanner() ||
    isViewer() ||
    isSuperAdmin() ||
    isAdmin() ||
    isOperator() ||
    isSupervisor()
  );
};

// export const postReminder = async (
//   id: string,
//   productLot: string,
//   productCode: string,
//   productName: string
// ) => {
//   // if ("Notification" in window && Notification.permission === "granted") {
//   const serviceWorkerRegistration = await navigator.serviceWorker.ready;
//   const data: IInprocessMessage = {
//     message: I18nTranslator(
//       translations.inProcessCheckReportDetail.inprocessCheckReminderMessage,
//       { lot: productLot, code: productCode, name: productName }
//     ),
//     title: I18nTranslator(
//       translations.inProcessCheckReportDetail.inprocessCheckReminderTitle
//     ),
//     id: id,
//     type: INPROCESS_EVENTS.PERFORM_ADDED,
//   };
//   serviceWorkerRegistration.active?.postMessage(data);
//   // }
// };

// export const pauseReminder = (id: string) => {
//   const serviceWorkerRegistration = navigator.serviceWorker.controller;
//   const data: IInprocessMessage = {
//     id: id,
//     type: INPROCESS_EVENTS.PAUSE_REMINDER,
//   };
//   serviceWorkerRegistration?.postMessage(data);
// };

// export const resumeReminder =  (id: string) => {
//   const serviceWorkerRegistration = navigator.serviceWorker.controller;
//   const data: IInprocessMessage = {
//     id: id,
//     type: INPROCESS_EVENTS.RESUME_REMINDER,
//   };
//   serviceWorkerRegistration?.postMessage(data);
// };
